<template>
  <div id="stepper" class="row d-flex justify-content-center align-items-center mx-1">
    <div class="steparea-wrp steparea-wrp-shadow w-100">
      <div class="text-dark">
        <div class="d-flex justify-content-center align-items-center">
          <ul
            id="stepper-progress"
            class="w-100 steps"
          >
            <li
              v-for="(titleLabel, idx) in tabList"
              :key="`step-${idx}`"
              class="step font-medium-5"
              :class="{ 'step-active': stepActive >= idx }"
            >
              {{ titleLabel }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepActive: { type: Number, default: 0 },
    tabList: { type: Array, default: [] },
  },
}
</script>

<style scope>
@import '~@/assets/css/pages/step-navbar.css';
</style>
